export default __webpack_public_path__ + "static/media/calendar.d6835757.svg";